import React from "react";
import { ChevronIcon } from "./ChevronIcon";

export const ChevronRightIcon = (props: React.ComponentProps<typeof ChevronIcon>) => <ChevronIcon {...props} direction="right" />;
